import { AxiosHeaders, Method, RawAxiosRequestHeaders } from 'axios';
import { ObjectType } from 'utils/types';

export type HttpClientProps = {
  url: string;
  method: Method;
  customHeader?: RawAxiosRequestHeaders | AxiosHeaders;
  params?: ObjectType;
  data?: ObjectType;
};

export type TQueryConfig = {
  manuallyHandlingErrorMsg?: boolean;
  disableSpinner?: boolean;
};

export type TQueryError = {
  status: number;
  errors?: string[];
  title?: string;
};

export enum API_RESPONSE_CODE {
  SUCCESS = 0,
  FAILED = -1,
}

export enum API_RESPONSE_STATUS {
  UNAUTHORIZED = 401,
}
